
export default{
    header:{
        logo: 'KEPLER DEVELOPER PLATFORM',
        discover: "DISCOVER",
        documents: "DOUMENTS",
        downloads: "DOWNLOADS",
        resourceDownloads: "Resource Downloads",
        appDownload: "APP Download",
        simulationDownloads: "Simulation Downloads",
        about: "ABOUT",
        userEntrance: "Register/Login",
        messages: "Messages",
        console: "Console",
        personalCenter : "Personal Center",
        logout : "Log Out",
    },
    footer:{
        aboutKepler : "About Kepler",
        ourStory : "Our Story",
        contactUs : "Contact Us",
        followorContactUs : "Follow or Contact Us",
        email: "Email",
        copyright1: `Copyright © gotokepler.com, All Rights Reserved.  `,
        // copyright2: " 沪ICP备 2023025649号-1"
    },
    discover:{
        coreTechnologies: "Core Technologies",
        learnMore: "Learn More",
        releasetime: "Release time",
        robotCapabilities: "Robot Capabilities",
        tryItNow: "Experience Now",
    },
    document:{
        enterkeywords: "Enter keywords",
        searchResults: "Search Results",
        total: 'A total of',
        results: "results",
        noMore: "No more content",
        documentDirectory: "Document Directory",
        pageGuide: "Page Guide",
        updateTime: "Update time",
        noContent: "No content yet",
        nodata: "No data",
    },
    download:{
        projectDirectory: "Project Directory",
        resourceDownloads: "Resource Downloads",
        download: "download",
        updateLog: "Update Log",
        noProjectTips: "No projects available, please contact the platform administrator for project customization.",
        appDownloadTitle: "KEPLER Control Platform",
        appDownloadDesc: "A high-fidelity training platform built for Kepler general-purpose humanoid robots",
        qrDownload: "Scan to download",
        downloadNow: "Download Now",
        kepler: "KEPLER",
        previous: 'Previous',
        next: 'Next',
        none: 'None',
        loading: 'Loading...',
        loadMore: 'Load More',
    },
    about: {
        programTitle_1: "Built-in Intelligent Programs",
        programContent_1: "It has multiple built-in intelligent programs, including visual recognition, navigation and walking functions. The developers can call them directly without additional development, improving development efficiency.",
        programTitle_2: "Detailed Reference Document",
        programContent_2: "Detailed documentation is provided, including interface descriptions, functional implementation principles, usage examples, etc., allowing users to quickly get started and develop their own applications.",
        programTitle_3: "Self-developed Operating System",
        programContent_3: "The developers can use the tools and resources in the open platform to gain an in-depth understanding of the inner workings of the robot and customize the development of functions and applications that meet their own needs.",
        programTitle_4: "Highly Open Platform",
        programContent_4: "From open source code to interface development, developers can easily interact and develop with the robot to realize various personalized functions and applications.",
        useTitle: 'How to Use the Developer Platform?',

        useContent: `Kepler OS is the first operating system for humanoid robots that is open to the outside world. It adopts a modular design and divides the robot system into multiple modules such as action execution, visual recognition, and voice interaction, and achieves a high degree of integration through open interfaces. Developers can develop various application modules as needed, and can also quickly build workflows and applications through visual programming tools.`,
        useContent2: 'The system provides sample projects and development documents to help developers get started quickly. It also supports multi-machine collaboration, allowing developers to easily connect and coordinate multiple robots through the network.',
        useContent3: `In addition, the system provides powerful online development and debugging capabilities. Developers can write programs and parameters online through the network, view the robot's operating status in real time, conduct remote control and problem location, and greatly improve research and development efficiency. In the future, Over-The-Air updates will be supported to enable remote upgrades and maintenance of robot firmware.`,
        useContent4: `In short, based on the concept of open collaboration, this operating system will greatly promote the development of robot software and help the deployment of robot applications.`,

        senceTitile: `What are the Application Scenarios of the Developer Platform?`,
        senceContent: 'Enable industrial / scientific research institutions to create customized intelligent solutions',
        senceDesc: 'Through the opener platform, developers can independently develop customized robots to implement various human-machine automation applications without paying attention to hardware details, greatly improving research and development efficiency.',
        senceTitle_1: "Unified Intelligence Platform",
        senceContent_1: "Each humanoid robot has been fully tested to provide a reliable platform for further development and achieve rapid implementation of intelligent solutions.",
        senceTitle_2: "1v1 Customized Solution",
        senceContent_2: "The partner integrator has an in-depth understanding of the factory's production process and customizes the 1v1 implementation workflow program according to the needs, so that the robot can better adapt to the factory's special needs.",
        senceTitle_3: "Quick Launch of Customized Application",
        senceContent_3: "Build personalized applications for enterprises, provide technical support and services to enterprises, and ensure long-term stable operation of the system.",
        bottomBanTitle: "Global Partners",
        bottomBanContent: "Join Hands to Create, and Sincerely Invite Global Partners",
        bottomBanDesc: "The development of humanoid robots should gather global talents. Kepler invites developers around the world to jointly create humanoid robot applications, realize intelligent solutions for scientific research and industrial applications, and jointly develop humanoid robot eco-system that changes the world!",
    },
    login:{
        accountLogin: "Account Login",
        pleaseEnterEmail: "Please enter email",
        incorrectEmailFormat: "Incorrect email format",
        pleaseEnterPassword: "Please enter password",
        pleaseWriterPassword: "Please enter password",
        pswRule: "Password length must be 6-20 characters",
        accountIncorrect: "Incorrect account or password",
        readAndAgreement: "I have read and agree to the ",
        and: "and",
        userAgreement: " User Agreement",
        privacyPolicy: "Privacy Policy",
        login: "Login",
        noAccount: "Don't have an account?",
        registerNow: "Register Now",
        forgetPsw: "Forgot Password",
        loginSuccess: 'Login successful!',
        confirmLogout: 'Confirm logout?',
        confirm: 'Confirm',
        cancel: 'Cancel',
        resetPassword: 'Reset Password',
        returnToLogin: 'Return to Account Login',
        verifyAccount: 'Verify Account',
        setNewPsw: 'Set New Password',
        resetPswSuccess: 'Password Reset Successful',
        nextStep: 'Next Step',
        setPassword: 'Set Password',
        confirmPsw: 'Confirm Password',
        accountPlaceholder: "Email address",
        writeAccount: "Please enter email",
        enterAccount: "Please enter email",
        pleaseAgreeWebTerms: "Please agree to the User Agreement and Privacy Policy",
    },
    register:{
        accountRegistration: "Account Registration",
        verificationCode: "verification code",
        pleaseEnterVerificationCode: "Please enter verification code",
        pleaseEnterEmailAddress: "Please enter email address",
        getVerificationCode: "Get Verification Code",
        resendCodeTips: "Resend in ",
        codeSend: "Verification code has been sent, please check.",
        rewrite: 'Incorrect verification code, please re-enter.',
        setPswRule: 'Please set a 6-20 character password',
        pleaseEnterPsw: 'Please enter password',
        pleaseConfirmPsw: 'Please confirm password',
        register: "Register",
        existingAccount: 'Already have an account? ',
        loginNow: "Login Now",
        registerSuccess: "Registration successful!",
        keepAccountSafe: 'Please keep your account information safe.',
        enterHomepage: "Go to Homepage",
        pswnomatch: "Passwords do not match, please re-enter",

    },
    personalCenter:{
        // 控制台
        myProjects: "My Projects",
        pleaseCertification: "No projects available, please complete developer certification first. ",
        certifiedDeveloper: "Developer Certification",
        developerCertification: "Developer Certification",
        submit: "Submit",
        submitCertificationInfo: "Submit Certification Materials",
        pendingReview: "Waiting for Material Review",
        certifiedSuccess: "Certification Successful",
        yourName: "Your Name",
        pleaseEnterRelName: "Please enter your name",
        pleaseEnterYourName: "Please enter your name",
        companyName: "Company Name",
        pleaseEnterRelCompanyName: "Please enter company name",
        pleaseEnterCompanyName: "Please enter company name",
        phoneNumber: "Contact Phone Number",
        writeTelOrEmail: "Please enter the contact person's email ",
        contactInfo: "Contact Information",
        writeContactInfo: "Please enter contact information",
        snCode: "Machine SN Code",
        writeSnCode: "Please enter the machine SN code",
        modifyProjectName: "Modify Project Name",
        newProjectName: "Please enter new project name",
        cannotEmpty: "Project name cannot be empty",
        operationSuccessful: "Operation Successful",
        resourceDownloads: "Resource Downloads",
        developmentDocuments: "Development Documents",
        accountInformation: "Account Information",
        accountName: "Account Name",
        accountCertification: "Account Certification",
        goCertify: "Go to Certify",
        certified: "Certified",
        details: "Details",
        individualDeveloper: 'Individual Developer',
        enterpriseDeveloper: 'Enterprise Developer',
        underCertification: 'Under certification',

        // 系统设置
        systemNotices: "System Announcements",
        more: "More",
        systemSettings: "System Settings",
        accountProfile: "Account Profile",
        basicInfo: "Basic Information",
        account: "Account",
        contactEmail: "Contact Email",
        notBoundYet: "Not Bound Yet",
        gotoBind: "Go to Bind",
        bindEmail: "Bind Email",
        writeBindEmail: "Please enter the email to bind",
        writeCodeYzm: "Please enter verification code",
        getVerificationCode: "Get Verification Code",
        cancel: "Cancel",
        confirm: "Confirm",
        accountPassword: "Account Password",
        gotoChange: "Go to Change",
        accountIdentity: "Account Identity",
        notObtainedYet : "Not Obtained Yet",
        gotoCertify: "Go to Certify",
        certified: "Certified",

        // 修改密码
        modifyPsw: "Change Password",
        originalPsw: "Current Password",
        writeOriginalPsw: "Please enter current password",
        newPsw: "New Password",
        confirmNewPsw: "Confirm new password",
        writeNewPsw: "Please enter new password",
        rewriteLoginPsw: "Re-enter New Password",
        writeOriginalPswWarn: 'Please enter your current password',
        writeNewPswWarn: 'Please enter a new password',
        rewriteLoginPswWarn: 'Please confirm your new password',

        // 系统通知
        systemNotice: "System Notifications",
        allAsRead: "Mark All as Read",
        noticeTitle: "Notification Title",
        certificationApproved: "Certification Approved",
        certificationNotApproved: "Certification Not Approved",
        status: "Status",
        read: "Read",
        unread: "Unread",
        type: "Type",
        certificationReview: "Certification Review",
        releaseTime: "Release Time",
        totalPage: "Total Pages",
        currentPage: " Currently Page",
        toPage: "Go to Page",
        page: '',
        noPermission: 'No viewing permission',
        noArticleTips: 'No article content available, check out other sections',
        noTips: 'No announcements',
        noNetwork: 'The network has wandered into outer space, take a break for now',
    },
    verificationTips:{
        telEmptyTips: 'Mobile number cannot be empty',
        telErrorTips: 'Mobile number format is incorrect',
        snCodeEmptyTips: 'Machine SN code cannot be empty',
        snCodeErrorTips: 'Machine SN code format is incorrect',
        nameEmptyTips: 'Name cannot be empty',
        nameErrorTips: 'Name length cannot exceed 20 characters',
        coNameEmptyTips: 'Company name cannot be empty',
        coNameErrorTips: 'Company name length cannot exceed 20 characters',
        yzmEmptyTips: 'Verification code cannot be empty',
        yzmErrorTips: 'Verification code must be a six-digit number',
        emailEmptyTips: 'Email cannot be empty',
        emailErrorTips: 'Email format is incorrect',
        accountEmptyTips: 'Please enter a mobile number or email address',
        accountErrorTips: 'Please enter a valid mobile number or email address',
        pswEmptyTips: 'Password cannot be empty',
        pswErrorTips: 'Password length must be 6-20 characters',
        serviceErrorTips: 'Operation failed, please try again later',
    },
    newDownload:{
        softwareLabel: "Software",
        studioTitle: "Kepler Studio",
        studioDesc: "An all-in-one visual robot development platform integrating graphical block programming, motion editing, logical operations, simulation preview, and one-click deployment.",
        systemTitle: "Exoskeleton Remote Control System",
        systemDesc: "A remote control system for robotic exoskeleton equipment, achieving real-time motion control, status monitoring, and job scheduling.",
        simulationTitle: "Simulation APP",
        simulationDesc: "Relying on digital twin technology, conduct full scene simulation and testing verification of robot motion trajectory and operation process.",
        viewAppTitle: "Show APP",
        viewAppDesc: "A smart robot display control app that supports device walking control, preset action calling, and one click switching of fun expressions.",
        btnText: "Try it now",
        dialogTitle: "Tips",
        dialogContent: "Insufficient permissions, please contact the staff",
        dialogConfirmText: "Confirm",
    }

}